import { ReactElement, useEffect, useState } from 'react';
import { FormikContextType } from 'formik';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import Multiselect from '../../../../components/UI/Input/Multiselect/Multiselect';
import { MultiselectTypes } from '../../../../components/UI/Input/Multiselect/_types';
import withComponentLoader from '../../../../hoc/withComponentLoader';
import AppWrappedInput from './AppWrappedInput';

/**
 * Multi-select input base component stylized to work with Custom App Request Form
 * @param {Object} props component properties
 * @param {Function} props.setLoading setter function coming from `withComponentLoader` HOC
 * @param {string} props.label display text
 * @param {FormikContextType} props.formik full Formik Context
 * @param {string|ReactElement} props.helperText helper text
 * @param {string[]} props.options list of options to display.  Should be list of strings.
 * @param {boolean} props.isRequired flag to determine whether to show required indicator
 * @param {boolean} props.isLoading flag to indicate the loading state (comes from parent)
 * @param {boolean} props.isDisabled flag to indicate when component should be disabled
 * @param {object} props.props the rest of the props
 * @returns Multi-select input stylized for custom
 */
const AppWrappedMultiselect = ({
	setLoading,
	label,
	formik,
	helperText,
	options = [],
	isRequired = false,
	isLoading = false,
	isDisabled = false,
	...props
}) => {
	const [optionsList, setOptionsList] = useState([]);

	useEffect(() => {
		if (options) {
			setOptionsList(
				options.map(o => {
					return {
						value: o,
						isSelected: formik.values[props.name].includes(o),
						isDisplayed: true,
					};
				})
			);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [options]);

	useEffect(() => {
		setLoading(isLoading);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isLoading]);

	useEffect(() => {
		if (optionsList && options.length > 0) {
			const newValue = optionsList
				.filter(o => o.isSelected)
				.map(o => o.value);
			formik.setFieldValue(props.name, newValue);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [optionsList]);

	return (
		<AppWrappedInput
			label={label}
			error={
				formik.touched[props.name] ? formik.errors[props.name] : null
			}
			isRequired={isRequired}
		>
			<FormControl variant='filled' fullWidth>
				<Multiselect
					name={props.name}
					options={optionsList}
					actionTitle={label}
					settings={{
						type: MultiselectTypes.LIST,
						selectHandler: e => {
							const newOptions = [...optionsList];
							newOptions[e].isSelected =
								!newOptions[e].isSelected;
							setOptionsList(newOptions);
							formik.setFieldTouched(props.name, true);
						},
						chipHandler: e => {
							const newOptions = [...optionsList];
							const index = newOptions.findIndex(
								o => o.value === e.value
							);
							if (index > -1) {
								newOptions[index].isSelected = false;
								setOptionsList(newOptions);
							}
						},
						isDisabled: isDisabled,
						isSelectAllable: true,
						// // selectAllHandler: () => {
						// // 	const newOptions = [...optionsList];
						// // 			newOptions[e].isSelected =
						// // 				!newOptions[e].isSelected;
						// // 			setOptionsList(newOptions);
						// // 			formik.setFieldTouched(props.name, true);
						// // },
						// isFilterable: true,
						// filterHandler: (targetValue, compareValue) => {
						// 	return compareValue.includes(targetValue);
						// },
					}}
					onBlur={() => formik.setFieldTouched(props.name, true)}
				/>
				<FormHelperText>{helperText}</FormHelperText>
			</FormControl>
		</AppWrappedInput>
	);
};
export default withComponentLoader(AppWrappedMultiselect);
